import React from 'react';
import { cssVariables } from 'styles';
import styles from './DonutWidget.module.scss';
import { DONUT_THICKNESS } from './helpers';

const donutRadius = (cssVariables.widgetBaseHeight - DONUT_THICKNESS) / 2;

const DonutWidgetLoading: React.FC = () => (
  <div className={styles.donut}>
    <div className={styles.chart}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={cssVariables.widgetBaseHeight}
        height={cssVariables.widgetBaseHeight}
        viewBox={`0 0 ${cssVariables.widgetBaseHeight} ${cssVariables.widgetBaseHeight}`}
      >
        <circle
          cx={donutRadius + DONUT_THICKNESS / 2}
          cy={donutRadius + DONUT_THICKNESS / 2}
          r={donutRadius}
          fill="none"
          strokeWidth={DONUT_THICKNESS}
          stroke="#f4f1f5"
        />
      </svg>
    </div>
    <div className={styles.legend}>
      <ul className={styles.loadingPlaceholderList}>
        {[...Array(7)].map((_, i) => (
          <li key={i} className={styles.item}>
            <span className={styles.loadingPlaceholderItem} />
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default DonutWidgetLoading;
